require("core-js/modules/es.array.reduce");

module.exports = function (e) {
  var n = {};

  function t(r) {
    if (n[r]) return n[r].exports;
    var o = n[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = n, t.d = function (e, n, r) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: r
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (t.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var o in e) {
      t.d(r, o, function (n) {
        return e[n];
      }.bind(null, o));
    }
    return r;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, t.p = "", t(t.s = 4);
}([function (e, n) {
  e.exports = require("react");
}, function (e, n, t) {
  e.exports = t(2)();
}, function (e, n, t) {
  "use strict";

  var r = t(3);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, n, t, o, i, a) {
      if (a !== r) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function n() {
      return e;
    }

    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: n,
      element: e,
      elementType: e,
      instanceOf: n,
      node: e,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return t.PropTypes = t, t;
  };
}, function (e, n, t) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, n, t) {
  "use strict";

  t.r(n);
  var r = t(0),
      o = t.n(r),
      i = t(1),
      a = t.n(i),
      u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      s = "object" === ("undefined" == typeof window ? "undefined" : u(window)) && "object" === ("undefined" == typeof document ? "undefined" : u(document)) && 9 === document.nodeType;

  function c(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var n = 0, t = new Array(e.length); n < e.length; n++) {
          t[n] = e[n];
        }

        return t;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  var p = "",
      f = "",
      l = "";

  if (s) {
    var d = {
      Moz: "-moz-",
      ms: "-ms-",
      O: "-o-",
      Webkit: "-webkit-"
    },
        m = document.createElement("p").style;

    for (var y in d) {
      if (y + "Transform" in m) {
        p = y, f = d[y];
        break;
      }
    }

    "Webkit" === p && "msHyphens" in m && (p = "ms", f = d.ms), "Webkit" === p && "-apple-trailing-word" in m && (l = "apple");
  }

  var b = {
    js: p,
    css: f,
    vendor: l
  };

  function g(e) {
    return "-" === e[1] ? e : "ms" === b.js ? e : "@" + b.css + "keyframes" + e.substr(10);
  }

  var v = {
    noPrefill: ["appearance"],
    supportedProperty: function supportedProperty(e) {
      return "appearance" === e && ("ms" === b.js ? "-webkit-" + e : b.css + e);
    }
  },
      x = /[-\s]+(.)?/g;

  function k(e, n) {
    return n ? n.toUpperCase() : "";
  }

  function j(e) {
    return e.replace(x, k);
  }

  function P(e) {
    return j("-" + e);
  }

  var h,
      w = {
    supportedProperty: function supportedProperty(e, n) {
      return !!/^break-/.test(e) && ("Webkit" === b.js ? "WebkitColumn" + P(e) in n && b.css + "column-" + e : "Moz" === b.js && "page" + P(e) in n && "page-" + e);
    }
  },
      O = {
    noPrefill: ["text-decoration-skip-ink"],
    supportedProperty: function supportedProperty(e) {
      return "text-decoration-skip-ink" === e && ("apple" === b.vendor ? "" + b.css + e : "Webkit" === b.js || "Moz" === b.js ? e : b.css + e);
    }
  },
      S = {
    noPrefill: ["color-adjust"],
    supportedProperty: function supportedProperty(e) {
      return "color-adjust" === e && ("Webkit" === b.js ? b.css + "print-" + e : e);
    }
  },
      T = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": ["box-orient", "box-direction"],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": ["box-orient", "box-direction"],
    "justify-content": "box-pack"
  },
      E = Object.keys(T),
      _ = function _(e) {
    return b.css + e;
  },
      W = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack"
  },
      A = [v, {
    noPrefill: ["transform"],
    supportedProperty: function supportedProperty(e, n, t) {
      return "transform" === e && (t.transform ? e : b.css + e);
    }
  }, {
    noPrefill: ["transition"],
    supportedProperty: function supportedProperty(e, n, t) {
      return "transition" === e && (t.transition ? e : b.css + e);
    }
  }, {
    noPrefill: ["mask"],
    supportedProperty: function supportedProperty(e, n) {
      if (!/^mask/.test(e)) return !1;

      if ("Webkit" === b.js) {
        if (j("mask-image") in n) return e;
        if (b.js + P("mask-image") in n) return b.css + e;
      }

      return e;
    }
  }, {
    noPrefill: ["writing-mode"],
    supportedProperty: function supportedProperty(e) {
      return "writing-mode" === e && ("Webkit" === b.js || "ms" === b.js ? b.css + e : e);
    }
  }, S, O, w, {
    supportedProperty: function supportedProperty(e, n) {
      if (!/^(border|margin|padding)-inline/.test(e)) return !1;
      if ("Moz" === b.js) return e;
      var t = e.replace("-inline", "");
      return b.js + P(t) in n && b.css + t;
    }
  }, {
    supportedProperty: function supportedProperty(e, n) {
      return j(e) in n && e;
    }
  }, {
    supportedProperty: function supportedProperty(e, n) {
      var t = P(e);
      return b.js + t in n ? b.css + e : "Webkit" !== b.js && "Webkit" + t in n && e;
    }
  }, {
    supportedProperty: function supportedProperty(e) {
      return "scroll-snap" === e.substring(0, 11) && ("ms" === b.js ? "" + b.css + e : e);
    }
  }, {
    supportedProperty: function supportedProperty(e) {
      return "overscroll-behavior" === e && ("ms" === b.js ? b.css + "scroll-chaining" : e);
    }
  }, {
    supportedProperty: function supportedProperty(e, n) {
      var t = W[e];
      return !!t && b.js + P(t) in n && b.css + t;
    }
  }, {
    supportedProperty: function supportedProperty(e, n, t) {
      var r = t.multiple;

      if (E.indexOf(e) > -1) {
        var o = T[e];
        if (!Array.isArray(o)) return b.js + P(o) in n && b.css + o;
        if (!r) return !1;

        for (var i = 0; i < o.length; i++) {
          if (!(b.js + P(o[0]) in n)) return !1;
        }

        return o.map(_);
      }

      return !1;
    }
  }],
      C = A.filter(function (e) {
    return e.supportedProperty;
  }).map(function (e) {
    return e.supportedProperty;
  }),
      M = A.filter(function (e) {
    return e.noPrefill;
  }).reduce(function (e, n) {
    return e.push.apply(e, c(n.noPrefill)), e;
  }, []),
      z = {};

  if (s) {
    h = document.createElement("p");
    var R = window.getComputedStyle(document.documentElement, "");

    for (var I in R) {
      isNaN(I) || (z[R[I]] = R[I]);
    }

    M.forEach(function (e) {
      return delete z[e];
    });
  }

  function N(e, n) {
    if (void 0 === n && (n = {}), !h) return e;
    if (null != z[e]) return z[e];
    "transition" !== e && "transform" !== e || (n[e] = e in h.style);

    for (var t = 0; t < C.length && (z[e] = C[t](e, h.style, n), !z[e]); t++) {
      ;
    }

    try {
      h.style[e] = "";
    } catch (e) {
      return !1;
    }

    return z[e];
  }

  s && document.createElement("p");
  /**
   * CSS Vendor prefix detection and property feature testing.
   *
   * @copyright Oleg Slobodskoi 2015
   * @website https://github.com/jsstyles/css-vendor
   * @license MIT
   */

  var B = function B(e) {
    var n = e.imagesCount,
        t = e.duration,
        r = e.transition,
        o = n * (t + r),
        i = Math.round(r / o * 100),
        a = Math.round((t + r) / o * 100),
        u = Math.round(1.1 * a),
        s = N("backface-visibility"),
        c = N("animation"),
        p = g("@keyframes"),
        f = "",
        l = "";
    return c && s && p && (f = "".concat(s, ": hidden;\n        ").concat(c, ": imageAnimation ").concat(o, "s linear infinite -0.5s;"), l = "".concat(p, " imageAnimation {\n          0% {\n            opacity: 0;\n            animation-timing-function: ease-in;\n          }\n          ").concat(i, "% {\n            opacity: 1;\n            animation-timing-function: ease-out;\n          }\n          ").concat(a, "% {\n            opacity: 1;\n          }\n          ").concat(u, "% {\n            opacity: 0\n          }\n          100% {\n            opacity: 0\n          }\n        }")), "#ReactBackgroundSlider > figure {\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        color: transparent;\n        background-size: cover;\n        background-position: center center;\n        background-repeat: no-repeat;\n        opacity: 0;\n        z-index: -1000;\n        margin: 0;\n        ".concat(f, "\n      }\n      ").concat(l, "\n    ");
  },
      q = function q(e, n) {
    var t = document.getElementsByTagName("head")[0],
        r = document.createElement("style");
    r.setAttribute("type", "text/css"), r.setAttribute("data-meta", n), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e)), t.appendChild(r);
  },
      D = "ReactBackgroundSlider";

  function U(e) {
    var n = e.images,
        t = e.duration,
        r = e.transition;
    return o.a.useEffect(function () {
      q(B({
        imagesCount: n.length,
        duration: t,
        transition: r
      }), D);
    }), o.a.createElement("div", {
      id: D
    }, n.map(function (e, n) {
      return o.a.createElement("figure", {
        key: n,
        style: {
          backgroundImage: "url(".concat(e, ")"),
          animationDelay: "".concat((t + r) * n, "s")
        }
      });
    }));
  }

  U.defaultProps = {
    duration: 10,
    transition: 2
  }, U.propTypes = {
    images: a.a.array.isRequired,
    duration: a.a.number,
    transition: a.a.number
  };
  var H = U;
  n.default = H;
}]);